import { render } from "./SwiperComponents.vue?vue&type=template&id=2e7e6bf2&scoped=true"
import script from "./SwiperComponents.vue?vue&type=script&lang=js"
export * from "./SwiperComponents.vue?vue&type=script&lang=js"

import "./SwiperComponents.vue?vue&type=style&index=0&id=2e7e6bf2&lang=css"
import "./SwiperComponents.vue?vue&type=style&index=1&id=2e7e6bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7e6bf2"]])

export default __exports__